var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FacetingService } from "../../../services/faceting.service";
import { SearchingService } from "../../../services/searching.service";
import { EduComponent } from "../../../utils/eduComponent";
var MobileFilterModalComponent = /** @class */ (function (_super) {
    __extends(MobileFilterModalComponent, _super);
    function MobileFilterModalComponent(activeModal, searchingService, facetingService) {
        var _this = _super.call(this) || this;
        _this.activeModal = activeModal;
        _this.searchingService = searchingService;
        _this.facetingService = facetingService;
        _this.totalCount = 0;
        _this.appliedFiltersCount = 0;
        return _this;
    }
    MobileFilterModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.searchingService.resultsCount.subscribe(function (count) { return (_this.totalCount = count); }));
        this.addSub(this.facetingService.filtersChanged.subscribe(function (data) {
            if (data) {
                _this.appliedFiltersCount = data.length;
            }
        }));
    };
    return MobileFilterModalComponent;
}(EduComponent));
export { MobileFilterModalComponent };
